<template>
  <div style="display: flex;">
    <div style="width: 30%;">
      <div style="text-align: center; padding: 20px 10px;">
        <img :src="form.avatar || $img.portrait" style="width: 80px; height: 80px; border-radius: 50%;" />
        <h4 style="margin: 10px 0 4px;">{{ form.nickname }}</h4>
        <p style="font-size: 13px; color: #0E7490;">{{ form.realstate == 3 ? '认证用户' : '未认证用户' }}</p>
        <el-button type="text" style="margin-top: 6px;" @click="$router.push('/admin/myself')">编辑信息</el-button>
      </div>
      <div style="padding: 0 24px;">
        <div class="xinxi"><p style="color: #000; display: inline;">邮箱：</p><p style="display: inline;">{{ form.mail }}</p></div>
        <div class="xinxi"><p style="color: #000; display: inline;">QQ：</p><p style="display: inline;">{{ form.qq }}</p></div>
        <div class="xinxi"><p style="color: #000; display: inline;">个人简介：</p><p style="display: inline;">{{ form.synopsis }}</p></div>
      </div>
    </div>
    <div style="width: 70%; padding: 20px;">
      <chart style="width: 100%;" :options="optioncontentshadow" :auto-resize="true"></chart>
    </div>
  </div>
</template>

<script>
import { getUser, getUserNumbering } from '@/api'

export default {
  name: 'AdminHome',
  data() {
    return {
      form: {},
      optioncontentshadow: {
        color: ['#3398DB'],
        tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' } },
        grid: { left: '3%', right: '4%', bottom: '3%', containLabel: true },
        xAxis: [{ type: 'category', data: ['问答交流', '校内活动', '文章新闻', '岗位', '二手'], axisTick: { alignWithLabel: true } }],
        yAxis: [{ type: 'value' }],
        series: [{ name: '内容数量', type: 'bar', barWidth: '60%', data: [] }]
      }
    }
  },
  created() {
    getUser().then((res) => {
      this.form = res.data || {}
    })
    getUserNumbering().then((res) => {
      const d = res.data || {}
      this.optioncontentshadow.series[0].data = [d.help, d.activity, d.article, d.job, d.oldstuff]
    })
  }
}
</script>

<style scoped>
.xinxi { margin-top: 18px; }
</style>
